module.exports = __webpack_public_path__ + "media/images/okra-offers/youtube-d79e577b5c5789eb425c976d121f9adb.svg";